/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_start_with_lorem = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with 'Lorem ipsum dolor…'`)
};

const es_li_start_with_lorem = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar con "Lorem ipsum dolor…"`)
};

const de_li_start_with_lorem = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit "Lorem ipsum dolor…" beginnen`)
};

const nl_li_start_with_lorem = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin met 'Lorem ipsum dolor…'`)
};

const fr_li_start_with_lorem = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer par "Lorem ipsum dolor…"`)
};

const it_li_start_with_lorem = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia con 'Lorem ipsum dolor…'`)
};

const pt_br2_li_start_with_lorem = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece com 'Lorem ipsum dolor…'`)
};

const pt_li_start_with_lorem = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar com 'Lorem ipsum dolor…'`)
};

const ja_li_start_with_lorem = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「Lorem ipsum dolor…」で始める`)
};

const zh_li_start_with_lorem = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以“Lorem ipsum dolor…”开头`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_start_with_lorem = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_start_with_lorem(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_start_with_lorem", locale)
	if (locale === "en") return en_li_start_with_lorem(inputs)
	if (locale === "es") return es_li_start_with_lorem(inputs)
	if (locale === "de") return de_li_start_with_lorem(inputs)
	if (locale === "nl") return nl_li_start_with_lorem(inputs)
	if (locale === "fr") return fr_li_start_with_lorem(inputs)
	if (locale === "it") return it_li_start_with_lorem(inputs)
	if (locale === "pt-BR") return pt_br2_li_start_with_lorem(inputs)
	if (locale === "pt") return pt_li_start_with_lorem(inputs)
	if (locale === "ja") return ja_li_start_with_lorem(inputs)
	return zh_li_start_with_lorem(inputs)
};